let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Q3IF8")).then(() => parcelRequire('1n59s'));